<template>
  <v-section-panel useBreak>
    <template v-slot:title>冊子印刷について</template>
    <template v-slot:content>
      <v-radio-group
        v-model="selectedPrintType"
        hide-details
        row>
        <v-radio
          v-for="(option, index) in options"
          :key="index"
          :label="option.text"
          :value="option.value"
          color="secondary"
        ></v-radio>
      </v-radio-group>
    </template>
  </v-section-panel>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'

export default {
  components: {
    VSectionPanel,
  },
  data: () => ({
    options: [
      {text: 'プリント型', value: 'print'},
      {text: '冊子型', value: 'booklet'},
    ],
  }),

  computed: {
    selectedPrintType: {
      get() {
        return this.$store.state.sheet.printType;
      },
      set(value) {
        this.$store.commit('sheet/setPrintType', { printType: value })
      }
    },
  },

  methods: {
    async createAnswerSeet(){
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
      this.$store.commit('sheet/setIsUpdate', {type: 'question', isUpdate: true})
      await this.$store.dispatch('sheet/getSheetImages', {params:{type:'question'}})
      this.$app.$refs.loading.close({})
    }
  },

  watch: {
    selectedPrintType(now, old) {
      if (now !== old) this.createAnswerSeet()
    }
  }
}
</script>
